module.exports = __webpack_public_path__ + "static/media/no.72a8e2fd.svg";